import { languageKey } from "./static";

export const authenticateUrl = "am/json/realms/members/authenticate";

export const authorizeUrl = "am/oauth2/realms/root/realms/members/authorize";

export const accessTokenUrl = "am/oauth2/realms/root/realms/members/access_token";

export const consentsUrl = "ServiceLayer/protected/v1/interoperability/members/consents";
export const devicesUrl = "am/json/realms/root/realms/members/authenticate";
export const revokeUrl = "/protected/v1/interoperability/members/consents/revoke-consentrevokeUrl";

export const accessTokenInterop = "am/oauth2/realms/root/realms/interop/access_token";

export const legalAndPrivacyDetailsURL = (languageCode: "en" | "es") =>
  `content/dam/hcsc/common/manage-my-account/unauthenticated-legal-and-privacy/${languageKey[languageCode]}.generic.json/experience/list/legal-and-privacy-list&membership/us-states`;
export const copyrightInfringementURL =
  "content/dam/hcsc/common/manage-my-account/unauthenticated-legal-and-privacy.generic.json/experience/list/legal-and-privacy-list&membership/us-states";

export const webAndMobilePrivacyURL = (languageCode: "en" | "es") =>
  `content/dam/hcsc/common/manage-my-account/unauthenticated-legal-and-privacy/${languageKey[languageCode]}.generic.json`;
// URL for Non-Discrimination-Notice
export const nonDiscriminationNoticeURL = (languageCode: "en" | "es") =>
  `content/dam/hcsc/common/manage-my-account/unauthenticated-legal-and-privacy/${languageKey[languageCode]}.generic.json/experience/list/legal-and-privacy-list&membership/us-states`; //related to TOU
export const webAndMobileTOUGeneral = "general/registration/unauthenticated/web-and-mobile-terms-of-use";
export const webAndMobileTOU = (languageCode: "en" | "es") =>
  `&content/dam/hcsc/common/manage-my-account/unauthenticated-legal-and-privacy/${languageKey[languageCode]}/`;

export const webAndMobileDetailsURL = (state: string | null, languageCode: "en" | "es") =>
  `content/dam/hcsc/common/manage-my-account/unauthenticated-legal-and-privacy/${languageKey[languageCode]}.generic.json/experience/list/legal-and-privacy-list&membership/us-states/${state}&experience/language/${languageCode}`;

export const scopesDescriptionURL = (state: string | null) =>
  `content/dam/hcsc/common/interoperability/consent-management-scopes.generic.json/membership/us-states/${state}&membership/member-type/member`;

export const medicalPoliciesPaymentAndCodingPolicies = (state: string | null, languageCode: "en" | "es") =>
  `content/dam/hcsc/common/manage-my-account/unauthenticated-legal-and-privacy/${languageKey[languageCode]}.generic.json/experience/list/legal-and-privacy-list&membership/us-states/${state}&experience/language/${languageCode}&content/dam/hcsc/common/manage-my-account/unauthenticated-legal-and-privacy/${languageKey[languageCode]}/${state}-general/registration/unauthenticated/bcbstx-medical-policies-and-bcbstx-clinical-payment-and-coding-policies`;

export const configUrl = "security-center/config";

export const returnUrl = "/security-center/return";
